const Disconnected = () => {
  return (
    <div className="min-h-screen bg-slate-50 px-6 py-10 text-slate-900">
      <div className="mx-auto flex min-h-[calc(100vh-5rem)] max-w-[1100px] items-center justify-center rounded-[24px] border border-slate-200 bg-white px-6 py-12 text-center shadow-[0_18px_40px_-28px_rgba(15,23,42,0.35)]">
        <div className="flex max-w-[420px] flex-col items-center gap-2">
          <img
            src="/Group.svg"
            alt="Page disconnected"
            className="w-full max-w-[220px]"
          />
          <h1 className="mt-2 text-2xl font-semibold">Page Disconnected</h1>
          <p className="text-sm text-slate-500">Try again later</p>
          <button
            type="button"
            className="mt-2 rounded-[10px] bg-slate-900 px-4 py-2 text-xs font-semibold text-white"
            onClick={() => window.location.reload()}
          >
            Refresh
          </button>
        </div>
      </div>
    </div>
  );
};

export default Disconnected;
